import { render, staticRenderFns } from "./v_Terms_PrivacyPolicy.vue?vue&type=template&id=c390c858&scoped=true&"
import script from "./v_Terms_PrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./v_Terms_PrivacyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./v_Terms_PrivacyPolicy.vue?vue&type=style&index=0&id=c390c858&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c390c858",
  null
  
)

export default component.exports